/**
 * Map canonical sensor IDs (Strain(1), …) to human-readable labels for the UI.
 * API calls and data keys always use the canonical ID.
 */
export function getSensorLabel(sensorId, labels = {}) {
  if (!sensorId) return '';
  return labels[sensorId] ?? sensorId;
}

export function buildDefaultStrainLabels(count = 17) {
  return Object.fromEntries(
    Array.from({ length: count }, (_, i) => {
      const id = `Strain(${i + 1})`;
      return [id, id];
    }),
  );
}

/** UI labels "1", "2", … for Strain(1), Strain(2), … */
export function buildNumberedStrainLabels(count = 30) {
  return Object.fromEntries(
    Array.from({ length: count }, (_, i) => [`Strain(${i + 1})`, String(i + 1)]),
  );
}

export function maxStrainIndexFromLabels(labels = {}) {
  const nums = Object.keys(labels)
    .map((key) => {
      const match = key.match(/^Strain\((\d+)\)$/);
      return match ? parseInt(match[1], 10) : 0;
    })
    .filter((n) => n > 0);
  return nums.length ? Math.max(...nums) : 0;
}
